import { render, staticRenderFns } from "./abilitySwan.vue?vue&type=template&id=be588482&scoped=true"
import script from "./abilitySwan.vue?vue&type=script&lang=js"
export * from "./abilitySwan.vue?vue&type=script&lang=js"
import style0 from "./abilitySwan.vue?vue&type=style&index=0&id=be588482&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be588482",
  null
  
)

export default component.exports